export const BREAKPOINTS = {
  XSMALL: '@media (min-width: 320px)',
  SMALL: '@media (min-width: 576px)',
  MEDIUM: '@media (min-width: 768px)',
  LARGE: '@media (min-width: 992px)',
  XLARGE: '@media (min-width: 1200px)',
};
